<template>
  <span>
    {{ label }}
  </span>
</template>

<script>

export default {
  props: [
      'tableId',
  ],
  computed: {
    table() {
      return this.$store.getters['tablesForSelect/list'].find(({value}) => Number.parseInt(value) === Number.parseInt(this.tableId));
    },
    label() {
      if (this.table) {
        return `${this.table.value} - ${this.table.label}`;
      }

      return this.tableId;
    }
  },
  async beforeMount() {
    await this.$store.dispatch('tablesForSelect/loadList')
  },
}
</script>
